<div class="mat-dialog-title">
  <span class="icon-learniz-offline" id="picto-offline"></span>
  <h1 [innerHTML]="'learniz.user-offline.message' | wording"></h1>
</div>
<div class="mat-dialog-content">
  <button mat-raised-button color="primary" class="btn-outline-primary" (click)="close()">
    {{ 'learniz.user-offline.button' | wording }}
  </button>
</div>
